"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var RedStar = function RedStar(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_Text.default, {
    className: className
  }, " * ");
};

RedStar.propTypes = {
  className: _propTypes.default.string
};

var _default = (0, _styledComponents.default)(RedStar).withConfig({
  displayName: "RedStar",
  componentId: "sc-14iw7mc-0"
})(["color:#ec4a41;font-size:14px;position:relative;top:-1px;"]);

exports.default = _default;